import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import '../styles/TimelineSection.css';

import history from '../Assets/Images/history.jpg';

const TimelineSection = () => {
  const { ref, inView } = useInView({ threshold: 0.3 });
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (inView) {
      setVisible(true);
      setTimeout(() => setVisible(false), 3000);
    }
  }, [inView]);

  return (
    <section className="timeline-section" id="evolution">
      <h2 className="timeline-title">EVOLUTION Of AKIJ</h2>
      <img src={history} alt="Akij Group History" className={`timeline-image ${visible ? 'come-down' : ''}`} ref={ref}/>
    </section>
  );
};

export default TimelineSection;
